import React from 'react';

interface CustomPopupProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const CustomPopup: React.FC<CustomPopupProps> = ({ open, title, message, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-xs w-full text-center font-['Pretendard-Regular']">
        <div className="text-lg font-bold mb-4 text-black truncate" style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{title}</div>
        <div className="text-base font-normal mb-6 text-black leading-snug break-keep">{message}</div>
        <button
          className="mt-2 px-8 py-2 bg-black text-white rounded-full font-semibold hover:bg-gray-800 transition text-base"
          onClick={onClose}
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default CustomPopup; 